import { render, staticRenderFns } from "./PatientsFormInformation.vue?vue&type=template&id=34622934&"
import script from "./PatientsFormInformation.vue?vue&type=script&lang=js&"
export * from "./PatientsFormInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports